export default class OcorrenciaTipo {
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.nome = '';
        this.descricao = '';
        this.cor = '#607D8B';
        this.permiteAnexo = false;
        this.permiteGravidade = false;
        this.ativo = true;

        if (!model)
            return;

        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId ? model.empresaId : 0;
        this.nome = model.nome;
        this.descricao = model.descricao;
        this.cor = model.cor ? model.cor : '#607D8B';
        this.permiteAnexo = model.permiteAnexo;
        this.permiteGravidade = model.permiteGravidade;
        this.ativo = model.ativo;

        if (model.createdAt)
            this.createdAt = model.createdAt;
        if (model.updatedAt)
            this.updatedAt = model.updatedAt;
    }
}
